
var Modal = require('ffss/ui/Modal');

class Waiting extends Modal {

	defaultOptions(){
		var self = this;
		var options = {
			//modal options
			'modalClass': 'waiting-modal',
			'verticalCentered': true,
			'modalSize': 'medium',
			'showFooter': false,
			'showHeader': false,
			'staticModal': true,

			//confirmModal options
			'messageClass': 'waiting-modal-message',
			'messageContent': null,
			'showLoader': true
		};
		return Object.assign(super.defaultOptions(),options);
	}

	constructor(options){
      	super(options);
      	//this.settings = $.extend(this.defaultOptions(),options);//done by super class

		// initialize attributes
		//this.$example = $('.class',this.$container);

		// bind events methods
		//this.onEvent = this.onEvent.bind(this);

		this.setBodyContent(this.buildContent());

	}

	buildContent(){
		var self = this;

		var $content = $('<div/>')
		.addClass('text-center');

		this.$message = $('<div/>')
		.addClass(this.settings.messageClass)
		.append(this.settings.messageContent);

		$content
		.append(this.$message);


		if(this.settings.showLoader){
			this.$message
			.append('<br/>')
			.append(
				$('<i/>')
				.addClass('fas fa-spin fa-spinner fa-2x')
			);
		}
		
		return $content;
	}

}

module.exports = Waiting;